import React, { useEffect } from "react";
import "./style.scss";
import successModalIcon from "../../assets/icons/success-modal-icon.png";
import { useNavigate } from "react-router-dom";


const SuccessModal = ({ msg, route }) => {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();


  const handleClose = (e) => {
    if (e) e.preventDefault();
    setOpen(false);
    if (route) {
      navigate(route)
    }

  };


  useEffect(() => {
    setOpen(true);
  }, []);

  return msg && open ? (
    <div className="success-modal-overlay">
      <div className="success-modal-container">
        <div className="success-modal-icon">
          <img src={successModalIcon} alt="" />
        </div>
        <div className="success-modal-info">
          <h2 className="modal-name">Success</h2>
          <p className="modal-description">
            Woo-hoo<br></br>
            {msg}
          </p>
        </div>
        <div className="success-modal-button">
          <button onClick={() => handleClose()} className="modal-button">
            Done
          </button>
        </div>
      </div>
    </div>
  ) : (
    false
  );
};

export default SuccessModal;
